/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeriesValueObjectDTO } from './SeriesValueObjectDTO';
import {
    SeriesValueObjectDTOFromJSON,
    SeriesValueObjectDTOFromJSONTyped,
    SeriesValueObjectDTOToJSON,
} from './SeriesValueObjectDTO';

/**
 * 
 * @export
 * @interface SeriesPointDTO
 */
export interface SeriesPointDTO {
    /**
     * 
     * @type {number}
     * @memberof SeriesPointDTO
     */
    completionRatio: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesPointDTO
     */
    isPreview: boolean;
    /**
     * 
     * @type {SeriesValueObjectDTO}
     * @memberof SeriesPointDTO
     */
    object?: SeriesValueObjectDTO;
    /**
     * 
     * @type {number}
     * @memberof SeriesPointDTO
     */
    step: number;
    /**
     * 
     * @type {number}
     * @memberof SeriesPointDTO
     */
    timestampMillis: number;
    /**
     * 
     * @type {string}
     * @memberof SeriesPointDTO
     */
    value?: string;
}

/**
 * Check if a given object implements the SeriesPointDTO interface.
 */
export function instanceOfSeriesPointDTO(value: object): value is SeriesPointDTO {
    if (!('completionRatio' in value) || value['completionRatio'] === undefined) return false;
    if (!('isPreview' in value) || value['isPreview'] === undefined) return false;
    if (!('step' in value) || value['step'] === undefined) return false;
    if (!('timestampMillis' in value) || value['timestampMillis'] === undefined) return false;
    return true;
}

export function SeriesPointDTOFromJSON(json: any): SeriesPointDTO {
    return SeriesPointDTOFromJSONTyped(json, false);
}

export function SeriesPointDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesPointDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'completionRatio': json['completionRatio'],
        'isPreview': json['isPreview'],
        'object': json['object'] == null ? undefined : SeriesValueObjectDTOFromJSON(json['object']),
        'step': json['step'],
        'timestampMillis': json['timestampMillis'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function SeriesPointDTOToJSON(value?: SeriesPointDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'completionRatio': value['completionRatio'],
        'isPreview': value['isPreview'],
        'object': SeriesValueObjectDTOToJSON(value['object']),
        'step': value['step'],
        'timestampMillis': value['timestampMillis'],
        'value': value['value'],
    };
}

